import React, {useState, useEffect} from "react";
import { ReactComponent as AngleUp } from 'assets/icons/angle-up.svg';
import { ReactComponent as AngleDown } from 'assets/icons/angle-down.svg';
import { ReactComponent as CloseIcon } from 'assets/icons/close.svg';
import { ReactComponent as PlusIcon } from 'assets/icons/plus.svg';
import { InputNumber, InputText, SelectDropdown, InputCheckBox } from "commons/input-controls";
import { connect } from "react-redux";
import { StandartButton } from "commons/form-controls";
import s from "./font-base.module.scss"



let mapStateToProps = (state) => ({
    fonts: state.ReportConstructor.fonts,
    colors: state.ReportConstructor.colors,
})

const FontBase = (props) => {
    const fontWeights = [
        {name: "", list: ""},
        {name: props.getValue('NORMAL'), list: 'NORMAL'},
        {name: props.getValue('BOLD'), list: 'BOLD'},
        {name: props.getValue('ITALIC'), list: 'ITALIC'},
        {name: props.getValue('UNDERLINED'), list: 'UNDERLINED'},
    ]

    const [isOpened, setIsOpened] = useState(false);
    const [fonts, setFonts] = useState(props.fonts);
    //const [selectedFont, setSelectedFont] = useState(props.parameters && props.parameters.font ? props.parameters.font : '');
    //const [selectedFontWeight, setSelectedFontWeight] = useState(props.parameters && props.parameters.fontFormatting ? props.parameters.fontFormatting : '');
    const [fontWeight, setFontWeight] = useState(fontWeights);
    const [fontSizes, setFontSizes] = useState(["", 8, 9, 10, 11, 12, 14, 16, 18, 20, 22, 24, 26, 28, 36, 48, 72]);
    //const [selectedFontSize, setSelectedFontSize] = useState(props.parameters && props.parameters.fontSize ? props.parameters.fontSize : '');
    //const [selectedFontColor, setSelectedFontColor] = useState(props.parameters && props.parameters.fontColour ? props.parameters.fontColour : '');
    const [parameters, setParameters] = useState(props.parameters ? {...props.parameters} : null);
    const [isShowColorBlock, setIsShowColorBlock] = useState(false);

    const angleButton = isOpened ? <AngleDown /> : <AngleUp /> 

    const setIsOpenedItem = () => {
        setIsOpened(!isOpened)
    }

    let getColorName = (color) => {
        let f = Object.entries(props.colors).filter(k => k[1] === color);
        if(f[0] && f[0][0]) return props.getValue(f[0][0]);
        else return color
    }


    const setSelectedColor = (key, value) => {
        let color = {}
        color[key] = value;
        //setSelectedFontColor(value);
        props.updateParameters(props.type, 'fontColour', value);
        setIsShowColorBlock(false);
    }

const colors = Object.entries(props.colors).map((k, i) => <div  key={i} 
                                                                className={s.colorItem} 
                                                                title={k[0]} 
                                                                onClick={setSelectedColor.bind(this, k[0], k[1])}>
                                                    <div className={s.color} style={{backgroundColor: '#'+k[1]}}></div>
                                                        <span>{props.getValue(k[0])}</span>
                                                    </div>);

    useEffect(() => {
        //setFonts(props.fonts);
        //setSelectedFont(props.parameters && props.parameters.font ? props.parameters.font : '');
        //setSelectedFontColor(props.parameters && props.parameters.fontColour ? props.parameters.fontColour : '');
        //setSelectedFontSize(props.parameters && props.parameters.fontSize ? props.parameters.fontSize : '');
        //setSelectedFontWeight(props.parameters && props.parameters.fontFormatting ? props.parameters.fontFormatting : '');
        setFontWeight(fontWeights);
        setParameters(props.parameters ? props.parameters : null);
    }, [props]);

    const showColorBlock = () => {
        setIsShowColorBlock(!isShowColorBlock);
    }

    const updateFont = (selectedFont) => {
        //setSelectedFont(selectedFont);
        props.updateParameters(props.type, 'font', selectedFont);
    }

    const updateFontWheight = (selectedFontWeight) => {
        props.updateParameters(props.type, 'fontFormatting', selectedFontWeight.list);
    }

    const updateFontSize = (selectedFontSize) => {
        //setSelectedFontSize(selectedFontSize);
        props.updateParameters(props.type, 'fontSize', selectedFontSize);
    }

    const removeParameter = () => {
        props.removeParameter();
    }

    const addParameter = () => {
        props.addParameter();
    }

    return (
        <div className={s.FontBase}>
            <div className={s.FontBaseHeader} onClick={setIsOpenedItem}>
                <span>{props.getValue('SET_UP_MAIN_FONT_BASE')}</span>
                <div className={s.headersButtonsBlock}>
                    <StandartButton background={'white'} icon={isOpened ? AngleDown : AngleUp } />
                        {parameters 
                            ? (!props.readOnly 
                                            ? <StandartButton icon={CloseIcon} background={'white'} callback={removeParameter}/> 
                                            : null )
                            : (!props.readOnly 
                                            ? <StandartButton icon={PlusIcon} background={'white'} callback={addParameter}/> 
                                            : null )
                            }
                </div>
            </div>
            { isOpened && parameters ? <div className={s.FontBaseBody}>
                <div className={s.FontSelectBlock}>
                    <SelectDropdown showOnly={props.readOnly} items={fonts} selected={parameters.font} setSelected={updateFont}/>
                    <div className={s.selectBlock}>
                        <SelectDropdown showOnly={props.readOnly} items={fontWeight} selected={parameters.fontFormatting ? props.getValue(parameters.fontFormatting) : ""} setSelected={updateFontWheight}/>
                        <SelectDropdown showOnly={props.readOnly} items={fontSizes} selected={parameters.fontSize} setSelected={updateFontSize}/>
                    </div>
                </div>
                <div className={s.FontColorBlock}>
                    <div className="formRow">
                        <div className="labelText">{props.getValue('FONT_COLOR')}</div>
                        <div>
                            <div className={s.selectedFontColor} onClick={showColorBlock}>
                                <div className={s.colorItem}>
                                    <div className={s.color} style={{background: "#"+parameters.fontColour}}></div>
                                    <span>{getColorName(parameters.fontColour)}</span>
                                </div>
                            </div>
                            {isShowColorBlock ? <div className={s.ColorBlock}>
                                { colors }
                            </div> : null }
                        </div>
                    </div>
                </div>
            </div> : null}
        </div>
    )
}

const FontBaseBlock = connect(mapStateToProps, {})(FontBase)

export default FontBaseBlock;